import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getFlatMetersAttachments = async (meterId) => {
  return await request.get(
    `/Meter/individual_meter/${meterId}/attachments`,
    {},
    'При загрузке вложений произошла ошибка',
    []
  );
};

const useFlatMetersAttachments = (meterId, options = {}) =>
  useQuery(
    getQueryKeys.flatMetersAttachments(meterId),
    () => getFlatMetersAttachments(meterId),
    {
      enabled: Boolean(meterId),
      ...options,
    }
  );

export default useFlatMetersAttachments;
